import omit from 'lodash/omit';
import { AnyAction, combineReducers } from 'redux';
import { createTransform, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// import { initialState } from '~/data/store/reducer/auth';
import { iActionLogout } from '~/domain/interfaces/redux/auth/Logout';
import auditRecord from './AuditRecord';
import consultant from './Consultant';
import notifications from './Notifications';
import professional from './Professional';
import administrator from './administrator';
import appointment from './appointment';
import appointmentPriorities from './appointmentPriorities';
import appointmentType from './appointmentType';
import auth from './auth';
import billing from './billing';
import chat from './chat';
import clinicalDocs from './clinicalDocs';
import dashboard from './dashboard';
import dataPagination from './dataPagination';
import duty from './duty';
import menu from './menu';
import message from './message';
import onCall from './onCall';
import orgUnit from './orgUnit';
import organizer from './organizer';
import permissions from './permissions';
import professions from './profession';
import selectedOrg from './selectedOrg';
import shifts from './shifts';
import teleShifts from './teleShifts';
import showModal from './showModal';
import specialty from './specialty';
import supportDoc from './supportDoc';
import users from './users';
import waitingroom from './waitingroom';
import healthUnits from './healthUnits';
import onCallRequest from './onCallRequest';
import onCallRequester from './onCallRequester';
import onCallSpecialist from './onCallSpecialist';
import diagnosisReport from './diagnosisReport';

const reducer = combineReducers({
  appointment,
  appointmentType,
  appointmentPriorities,
  menu,
  auth,
  users,
  message,
  specialty,
  professional,
  consultant,
  supportDoc,
  permissions,
  clinicalDocs,
  professions,
  waitingroom,
  chat,
  notifications,
  selectedOrg,
  dataPagination,
  showModal,
  organizer,
  administrator,
  dashboard,
  orgUnit,
  billing,
  auditRecord,
  duty,
  onCall,
  shifts,
  healthUnits,
  onCallRequest,
  onCallRequester,
  onCallSpecialist,
  diagnosisReport,
  teleShifts,
});

// export type RootState = ReturnType<typeof rootReducer>;

// const store = createStore(reducer);

interface iLogout {
  logoutApplication: iActionLogout;
  state: any;
}

const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === '@auth/LOGOUT') {
    storage.removeItem('persist:reducers');
    return reducer(undefined, action);
  }

  return reducer(state, action);
};

// Blacklist specific property to not persist on LocalStorage
const blacklistProperty = (blacklistPaths: Array<string>) => {
  return createTransform((inboundState: any, key) => {
    const blacklistPathsForKey = blacklistPaths
      .filter(path => path.startsWith(`${String(key)}.`))
      .map(path => path.substr(String(key).length + 1));

    return omit(inboundState, ...blacklistPathsForKey);
  }, null);
};

const authPersistConfig = {
  key: 'reducers',
  storage,
  blacklist: ['message', 'showModal', 'teleShifts'],
  transforms: [
    blacklistProperty([
      'auth.loading',
      'auth.errorCount',
      // 'appointment.date',
      'appointment.loading',
      'chat.loading',
      'clinicalDocs.loading',
      'notifications.loading',
      'permissions.loading',
      'professions.loading',
      'specialty.loading',
      'supportDoc.loading',
      'users.loading',
    ]),
  ],
};

export default persistReducer(authPersistConfig, rootReducer);
